<template>
  <div>
    <a-row :gutter="24">
      <a-col
        :span="24"
        :lg="12"
        :xl="6"
        class="mb-24"
        v-for="(stat, index) in stats"
        :key="index"
      >
        <!-- Widget 1 Card -->
        <WidgetCounter
          :title="stat.title"
          :value="stat.value"
          :prefix="stat.prefix"
          :suffix="stat.suffix"
          :icon="stat.icon"
          :status="stat.status"
        ></WidgetCounter>
        <!-- / Widget 1 Card -->
      </a-col>
    </a-row>

    <a-row :gutter="24">
      <a-col :span="12" :lg="12" :xl="24" class="mb-24">
        <a-card class="card card-body border-0">
          <template #title>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <h6>Liste des controles du collecteur "{{ collecteur }}"</h6>

              <a-button class="mx-2" type="primary" danger @click="exportDataFromJSON(data)">Export</a-button>
              <a-button class="mx-2" @click="$router.go(-1)">Retour</a-button>
            </div>
          </template>
          <a-table :columns="columns" :data-source="data" :pagination="true">
            <template slot="etat" slot-scope="text, record">
              <span class="text-success" v-if="record.etat == true"
                >Success</span
              >
              <span class="text-danger" v-if="record.etat == false"
                >Problème</span
              >
            </template>
            <template slot="operation" slot-scope="text, record">
              <a-popconfirm
                title="Etes vous Sûr de resoudre?"
                @confirm="() => resolve(record.key)"
                ><a-button
                  :disabled="record.etat == true"
                  type="danger"
                  size="small"
                  >Resoudre</a-button
                >
              </a-popconfirm>
            </template>
          </a-table>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>
  
<script>
// Counter Widgets
import WidgetCounter from "../../components/Widgets/WidgetCounter";
import exportFromJSON from 'export-from-json'
const columns = [
  {
    title: "Date de creation",
    dataIndex: "created_at",
    key: "created_at",
    scopedSlots: { customRender: "name" },
  },
  {
    title: "Nom/Prénom client",
    dataIndex: "nom_client",
    key: "nom_client",
  },
  {
    title: "Nom/Prénom carnet",
    dataIndex: "nom_carnet",
    key: "nom_carnet",
  },
  {
    title: "Nbr mois",
    dataIndex: "nbr_mois",
    key: "nbr_mois",
  },
  {
    title: "Nbr jours",
    dataIndex: "nbr_jours",
    key: "nbr_jours",
  },
  {
    title: "Cotisation controle (Fcfa)",
    dataIndex: "cotisation_c",
    key: "cotisation_c",
  },
  {
    title: "Cotisation réelle (Fcfa)",
    dataIndex: "cotisation",
    key: "cotisation",
  },
  {
    title: "Etat",
    dataIndex: "etat",
    key: "etat",
    scopedSlots: { customRender: "etat" },
  },
  {
    title: "Action",
    key: "Action",
    scopedSlots: { customRender: "operation" },
  },
];
export default {
  created() {},
  components: {
    WidgetCounter,
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  data() {
    return {
      callback: process.env.VUE_APP_API_BASE_URL,
      callbackControle: process.env.VUE_APP_API_BASE_URL_CONTROLE,
      token_admin: null,
      stats: [],
      width: 1000,
      columns,
      data: [],
      buttonText: "Détail",
      visible: false,
      confirmLoading: false,
      collecteur: null,
      nom: null,
      prenom: null,
      numero: null,
      ville: null,
      quartier: null,
      password: null,
      dette: null,
      type: 0,
    };
  },
  mounted() {
    this.stats = [
      {
        title: "Nombre de controle",
        value: 0,
        prefix: "",
        suffix: "",
        icon: `<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.43338 7.41784C8.58818 7.31464 8.77939 7.2224 9 7.15101L9.00001 8.84899C8.77939 8.7776 8.58818 8.68536 8.43338 8.58216C8.06927 8.33942 8 8.1139 8 8C8 7.8861 8.06927 7.66058 8.43338 7.41784Z" fill="#111827"/>
                              <path d="M11 12.849L11 11.151C11.2206 11.2224 11.4118 11.3146 11.5666 11.4178C11.9308 11.6606 12 11.8861 12 12C12 12.1139 11.9308 12.3394 11.5666 12.5822C11.4118 12.6854 11.2206 12.7776 11 12.849Z" fill="#111827"/>
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 5C11 4.44772 10.5523 4 10 4C9.44772 4 9 4.44772 9 5V5.09199C8.3784 5.20873 7.80348 5.43407 7.32398 5.75374C6.6023 6.23485 6 7.00933 6 8C6 8.99067 6.6023 9.76515 7.32398 10.2463C7.80348 10.5659 8.37841 10.7913 9.00001 10.908L9.00002 12.8492C8.60902 12.7223 8.31917 12.5319 8.15667 12.3446C7.79471 11.9275 7.16313 11.8827 6.74599 12.2447C6.32885 12.6067 6.28411 13.2382 6.64607 13.6554C7.20855 14.3036 8.05956 14.7308 9 14.9076L9 15C8.99999 15.5523 9.44769 16 9.99998 16C10.5523 16 11 15.5523 11 15L11 14.908C11.6216 14.7913 12.1965 14.5659 12.676 14.2463C13.3977 13.7651 14 12.9907 14 12C14 11.0093 13.3977 10.2348 12.676 9.75373C12.1965 9.43407 11.6216 9.20873 11 9.09199L11 7.15075C11.391 7.27771 11.6808 7.4681 11.8434 7.65538C12.2053 8.07252 12.8369 8.11726 13.254 7.7553C13.6712 7.39335 13.7159 6.76176 13.354 6.34462C12.7915 5.69637 11.9405 5.26915 11 5.09236V5Z" fill="#111827"/>
                          </svg>`,
      },
      {
        title: "Dette accumulée",
        value: 0,
        prefix: "",
        suffix: "Fcfa",
        icon: `<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.43338 7.41784C8.58818 7.31464 8.77939 7.2224 9 7.15101L9.00001 8.84899C8.77939 8.7776 8.58818 8.68536 8.43338 8.58216C8.06927 8.33942 8 8.1139 8 8C8 7.8861 8.06927 7.66058 8.43338 7.41784Z" fill="#111827"/>
                              <path d="M11 12.849L11 11.151C11.2206 11.2224 11.4118 11.3146 11.5666 11.4178C11.9308 11.6606 12 11.8861 12 12C12 12.1139 11.9308 12.3394 11.5666 12.5822C11.4118 12.6854 11.2206 12.7776 11 12.849Z" fill="#111827"/>
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 5C11 4.44772 10.5523 4 10 4C9.44772 4 9 4.44772 9 5V5.09199C8.3784 5.20873 7.80348 5.43407 7.32398 5.75374C6.6023 6.23485 6 7.00933 6 8C6 8.99067 6.6023 9.76515 7.32398 10.2463C7.80348 10.5659 8.37841 10.7913 9.00001 10.908L9.00002 12.8492C8.60902 12.7223 8.31917 12.5319 8.15667 12.3446C7.79471 11.9275 7.16313 11.8827 6.74599 12.2447C6.32885 12.6067 6.28411 13.2382 6.64607 13.6554C7.20855 14.3036 8.05956 14.7308 9 14.9076L9 15C8.99999 15.5523 9.44769 16 9.99998 16C10.5523 16 11 15.5523 11 15L11 14.908C11.6216 14.7913 12.1965 14.5659 12.676 14.2463C13.3977 13.7651 14 12.9907 14 12C14 11.0093 13.3977 10.2348 12.676 9.75373C12.1965 9.43407 11.6216 9.20873 11 9.09199L11 7.15075C11.391 7.27771 11.6808 7.4681 11.8434 7.65538C12.2053 8.07252 12.8369 8.11726 13.254 7.7553C13.6712 7.39335 13.7159 6.76176 13.354 6.34462C12.7915 5.69637 11.9405 5.26915 11 5.09236V5Z" fill="#111827"/>
                          </svg>`,
      },
    ];

    this.listDemande();
  },
  methods: {
    showAlert(type, title, description) {
      this.$notification[type]({
        message: title,
        description: description,
      });
    },

    exportDataFromJSON(data) {
      if (!data) { message.warning('Data not found') }
      else {
        try {
          const fileName = "exported-data";
          const exportType = exportFromJSON.types["xls"];
          exportFromJSON({ data, fileName, exportType });
        } catch (e) {
          throw new Error("Parsing failed!");
        }
      }
    },

    listDemande() {
      let session = localStorage;
      this.token_controle = session.getItem("tokenControle");

      let headers = { headers: { Authorization: this.token_controle } };

      this.$http
        .get(
          `${this.callbackControle}/collecte/getByIdCollecteur/${this.$route.params.id}`,
          headers
        )
        .then(
          (response) => {
            let data = response.body.data;
            this.stats[0].value = data.length;

            this.collecteur = data[0].nom_collecteur;
            this.data = [];
            this.dette = 0;
            console.log(data);
            for (let i = 0; i < data.length; i++) {
              let somme =
                (parseInt(data[i].id_mois) * 31 + parseInt(data[i].nbr_jours)) *
                parseInt(data[i].mise);
              if (data[i].etat == false) {
                this.dette += somme - data[i].cotisation_total;

                this.stats[1].value = this.dette;
              }

              this.data.push({
                key: data[i].id,
                created_at: new Date(data[i].created_at).toLocaleString(),
                nom_client: data[i].nom_client,
                nom_carnet: data[i].nom_carnet,
                nbr_mois: data[i].id_mois,
                nbr_jours: data[i].nbr_jours,
                cotisation_c: somme,
                cotisation: data[i].cotisation_total,
                etat: data[i].etat == true ? true : false,
              });
            }
          },
          (response) => {
            this.showAlert("error", "Erreur", response.body.message);
          }
        );
    },

    showModal() {
      this.visible = true;
    },

    handleOk(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log(values);
          this.confirmLoading = true;
          this.chefSubmit(values);
          setTimeout(() => {
            this.listechef();
            this.visible = false;
            this.confirmLoading = false;
          }, 2000);
        } else {
          console.log("error");
        }
      });
    },

    handleCancel(e) {
      console.log("Clicked cancel button");
      this.visible = false;
    },

    resolve(id) {
      let session = localStorage;
      this.token_controle = session.getItem("tokenControle");

      let headers = { headers: { Authorization: this.token_controle } };

      this.$http
        .post(
          `${this.callbackControle}/collecte/update/${id}`,
          { etat: true },
          headers
        )
        .then((response) => {
          let data = response.body;

          console.log(data);
          if (data.status == true) {
            this.showAlert(
              "success",
              "Success",
              "Problem resolus avec success"
            );

            this.listDemande();
          } else {
            this.showAlert(
              "danger",
              "Erreur",
              "Probleme non resolue suite une erreur"
            );
          }
        });
    },
  },
};
</script>